import { Component } from '@angular/core';

@Component({
  selector: 'app-tables-demo',
  templateUrl: './tables-demo.component.html',
})
export class TablesDemoComponent {}
